const Constants = {
    URL: {
        root: 'https://www.justpictureframingonline.com.au',
        ImageURL: 'https://www.justpictureframingonline.com.au/wp-content/uploads/customizer-images/webimages'
    },
    MAX_IMAGE_DIMENSIONS_CM: '125 x 125',
    MIN_IMAGE_DIMENSIONS_CM: '20 x 20',
    SITE_TITLE: 'Just Picture Framing',
    Currency: 'AU $',
    MAX_QTY: 100,
}
module.exports = Constants;